import { Controller } from 'react-hook-form';
import { SidePanelRow, InputText, ToggleInput } from '@ui/src';
import { WebhooksFormTypes } from './types';

import cn from './styles.module.css';

const WebhooksForm = ({
  control,
  errors,
  onSubmit,
  children,
}: WebhooksFormTypes): React.JSX.Element => (
  <form onSubmit={onSubmit} className={cn.details}>
    <SidePanelRow caption="Webhook URI">
      <Controller
        control={control}
        name="webHookUri"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            placeholder="Enter webhook URI..."
            name={name}
            value={value}
            onChange={onChange}
            error={errors?.webHookUri?.message}
          />
        )}
      />
    </SidePanelRow>
    <div className={cn.brandColorsTitle}>Webhook Events</div>
    <SidePanelRow>
      <Controller
        control={control}
        name="applicationChange"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Application Change"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    <SidePanelRow>
      <Controller
        control={control}
        name="organizationChange"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Organization Change"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    <SidePanelRow>
      <Controller
        control={control}
        name="organizationCreate"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Organization Create"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    <SidePanelRow>
      <Controller
        control={control}
        name="transactionChange"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Transaction Change"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    {children}
  </form>
);

export default WebhooksForm;
